import './style/css/spmoverlay.css';

import React, { useState } from 'react';

import SPM from './components/SPM';

const App = () => {
  const [data, setData] = useState({ showSPM: false, payload: null });

  const initiatePayment = payload => {
    setData({ showSPM: true, payload });
  };

  window.SPM.initiatePayment = initiatePayment;

  return (
    <>
      {data.showSPM && (
        <SPM
          payload={data.payload}
          loadRazorpay={data.showSPM}
          hideInsufficientMilesPopup={
            typeof data.payload.hideInsufficientMilesPopup !== 'undefined'
              ? JSON.parse(data.payload.hideInsufficientMilesPopup)
              : false
          }
        />
      )}
    </>
  );
};

export default App;

window.SPM = App;
